import parseHtml from "lib/parser";
export default function HTMLRenderedBlock(props) {
  const content = props.isDynamic ? props.dynamicContent : props.saveContent;
  return <>{parseHtml(content)}</>;
}
